module.exports = __webpack_public_path__ + "logo-ENAP.jpg?05400549a0a16e89f3e889a01863364e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/logo-ENAP.jpg
// module id = 77
// module chunks = 0